import { SelectionValidator } from "../class/_selectionValidator.js";

/**
 * チェックボックスの選択状況に応じてフォームの表示を切り替える
 */
export const inputBranch = () => {
  const selection = document.querySelector( '.js-selection--branch' );

  if ( selection !== null ) {
    const form = document.querySelector( 'form.p-form' );
    const validate = new SelectionValidator( selection );

    const hideItems = document.querySelectorAll( '.js-hide' );
    hideItems.forEach( hideItem => {
      hideItem.style.display = 'none';
    } );

    form.addEventListener( 'change', () => {
      validate.validateRun();
      if ( validate.errorCount !== 0 ) {
        hideItems.forEach( hideItem => {
          hideItem.style.display = 'none';
        } );
      } else {
        hideItems.forEach( hideItem => {
          hideItem.style.display = 'block';
        } );
      }
    } );
  }
}
